import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useGetCancellationPolicyFeatureFlagDetails = () => {
  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const [isCancellationPolicyEnabled, isLoadingWetag] = ScheduleOrg.useWetag('cancellation-policy');

  const isLoading = isLoadingV3Flag || isLoadingWetag;

  return {
    isCancellationPolicyEnabled: isLoading ? false : isScheduleV3FlagEnabled && isCancellationPolicyEnabled,
    isLoading,
  };
};
